import React from "react";
import { portfolio } from "../mock";
import { SectionBanner } from "./About";
import { asset } from "../assetBase";
import { ExternalLink, ImageOff } from "lucide-react";

const Portfolio = () => {
  return (
    <>
      <SectionBanner title="Portfolio" id="portfolio" />
      <section className="bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-24 space-y-24">
          {portfolio.map((item, i) => (
            <div
              key={i}
              className={`reveal grid md:grid-cols-2 gap-10 md:gap-14 items-center ${
                i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-start gap-2"
                >
                  <h3 className="font-head font-bold text-neutral-800 text-2xl md:text-3xl leading-snug underline decoration-lime-500 decoration-2 underline-offset-4 group-hover:text-lime-600 transition-colors">
                    {item.title}
                  </h3>
                  <ExternalLink
                    size={20}
                    className="mt-1 shrink-0 text-lime-500 opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </a>
                <div className="mt-6 space-y-4 text-neutral-600 tracking-body leading-relaxed text-[15px]">
                  {item.body.map((b, j) => (
                    <p key={j}>{b}</p>
                  ))}
                </div>
              </div>

              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block overflow-hidden rounded-lg shadow-lg border border-neutral-100"
              >
                {item.image ? (
                  <img
                    src={asset(item.image)}
                    alt={item.title}
                    className="w-full object-cover transition-transform duration-500 hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full aspect-[16/9] flex flex-col items-center justify-center gap-3 bg-neutral-100 text-neutral-400 border border-dashed border-neutral-300">
                    <ImageOff size={34} />
                    <span className="text-xs tracking-body px-6 text-center">
                      Original image not in archive &mdash; ready to re-upload
                    </span>
                  </div>
                )}
              </a>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Portfolio;
